import { useEffect } from 'react';
import { useUiModalStore } from '../store/uiModalStore';
import { useExtensionStore } from './store';
import { installApiClientGate } from './apiClientSwitch';
import { notifyApiClientOff } from './apiClientOffNotice';

/**
 * Mounts the API Client gate (extensions/apiClientSwitch.js) for as long as
 * the rail is on screen — which is always. One subscription pair per mount.
 * An attempt to open one of its pages while it is off says so, with a
 * "Turn on" that then opens the page that was asked for.
 */
export default function useApiClientGate() {
  useEffect(
    () =>
      installApiClientGate(useUiModalStore, useExtensionStore, {
        onBlocked: (tab) => notifyApiClientOff({ reopen: () => useUiModalStore.getState().setActiveTab(tab) }),
      }),
    []
  );
}
